// extracted by mini-css-extract-plugin
export default {"wrapper":"H27479vasf6TJzJYBmuY","targetWrapper":"Tnujaq9Kwv2spaqajAMQ","targetType":"GEiDHF3mrIt1mBK6ZZ6W","targetProgressValue":"AIKBEgxIe0tRbgqfjTZQ"};